var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('component',_vm._b({class:_vm.reportType,attrs:{"reload":_vm.reload}},'component',_vm.chartProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }